export default __webpack_public_path__ + "static/media/loader.279db549.gif";